import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaAngleRight } from "react-icons/fa";
import { Slider } from "./Slider";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../config/supabaseClient";

function MySection({ main }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [articles, setArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [totalArticles, setTotalArticles] = useState(0);
  const articlesPerPage = 6;
  useEffect(() => {
    const links = [
      "https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/brands.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/fontawesome.min.css",
    ];
    links.forEach((href) => {
      const link = document.createElement("link");
      link.href = href;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    });
  }, []);

  // Fetch articles for the current page
  useEffect(() => {
    const fetchArticles = async () => {
      let query = supabase
        .from("projects")
        .select("*")
        .order("created_at", { ascending: false });

      if (location?.pathname === "/projects") {
        query = query.range(
          (page - 1) * articlesPerPage,
          page * articlesPerPage - 1
        );
      } else {
        query = query.limit(4);
      }
      const { data, error } = await query;
      if (error) {
        console.error("Error fetching articles:", error);
      } else {
        setArticles(data);
      }
    };

    fetchArticles();
  }, [page]);
  // Fetch signed URLs for images
  useEffect(() => {
    const fetchSignedUrls = async () => {
      const urls = {};
      for (const article of articles) {
        const { data: signedUrlData, error } = await supabase.storage
          .from("project-images")
          .createSignedUrl(article.image_link, 60);

        if (error) {
          console.error("Error getting signed URL:", error);
        } else {
          urls[article.id] = signedUrlData.signedUrl;
        }
      }
    };

    if (articles.length > 0) {
      fetchSignedUrls();
    }
  }, [articles]);

  const totalPages = Math.ceil(totalArticles / articlesPerPage);
  return (
    <Section>
      <Container>
        <Title className={main ? "main-page" : ""}>
          Premium Luxury Developments
        </Title>
        <CardsWrapper>
          {!!articles &&
            articles.map((item, index) => {
              return (
                <Card
                  key={index}
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    border: "1px solid rgb(167, 140, 76)",
                  }}
                >
                  {/* SOLD/UNSOLD STRIP */}
                  <div
                    style={{
                      position: "absolute",
                      top: 10,
                      left: -10,
                      backgroundColor: item.sold ? "#ff4d4f" : "#52c41a",
                      color: "white",
                      padding: "4px 12px",
                      borderRadius: "0 6px 6px 0",
                      fontWeight: "bold",
                      fontSize: "12px",
                      zIndex: 2,
                    }}
                  >
                    {item.sold ? "SOLD" : "AVAILABLE"}
                  </div>

                  {/* FIXED HEIGHT IMAGE */}
                  <div className="project-img-fix">
                    <Slider images={item.images} />
                  </div>

                  {/* CARD CONTENT */}
                  <CardContent
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      padding: "16px",
                    }}
                    onClick={() => navigate(`/projects/${item.id}`)}
                  >
                    {/* Middle Text Content */}
                    <div style={{ flexGrow: 1 }}>
                      <TopRow>
                        <p style={{ margin: 0 }}>
                          <b>{item.title}</b>
                        </p>
                      </TopRow>
                      <p>{item.price} AED</p>
                      <p>Area : {item.area}</p>
                      <p>
                        <i
                          className="fa-solid fa-location-dot"
                          style={{ marginRight: "6px", color: "#c8c8c8" }}
                        ></i>
                        {item.location}
                      </p>
                    </div>

                    {/* Bottom-Aligned Button */}
                    <ButtonWrapper style={{ marginTop: "16px" }}>
                      <ViewButton>
                        View more detail <FaAngleRight />
                      </ViewButton>
                    </ButtonWrapper>
                  </CardContent>
                </Card>
              );
            })}
        </CardsWrapper>
      </Container>
      {location?.pathname === "/projects" && (
        <Pagination>
          <PageButton onClick={() => setPage(page - 1)} disabled={page === 1}>
            Previous
          </PageButton>
          <span>
            Page {page} of {totalPages}
          </span>
          <PageButton
            onClick={() => setPage(page + 1)}
            disabled={page === totalPages}
          >
            Next
          </PageButton>
        </Pagination>
      )}
    </Section>
  );
}

export default MySection;

// Styled Components
const Section = styled.div`
  font-family: "Poppins", sans-serif;
  padding: 40px 20px;
  background-color: #fff;
`;

const Container = styled.div`
  max-width: 1300px;
  margin: auto;
  padding: 0 20px;
  @media (max-width: 768px) {
    padding: 0px;
  }
  @media (min-width: 1200px) {
    padding: 0 40px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #111;
  font-family: "Paris Avenue";

  @media (min-width: 768px) {
    font-size: 28px;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;

  & > * {
    flex: 1 1 calc(25% - 30px); /* Max 4 items per row, accounting for gap */
    max-width: calc(25% - 30px);
  }

  @media (max-width: 1024px) {
    & > * {
      flex: 1 1 calc(33.333% - 20px); /* 3 per row */
      max-width: calc(33.333% - 20px);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    & > * {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
`;

const Card = styled.div`
  border: 1px solid rgb(167, 140, 76);
  border-radius: 0px;
  overflow: hidden;
  width: 100%;
  background-color: #fafafa;
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 768px) {
    width: 48%;
  }

  @media (min-width: 1024px) {
    width: 30%;
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 260px;
  object-fit: cover;
  padding: 4px;
`;

const CardContent = styled.div`
  padding: 20px;
  font-size: 14px;

  p {
    margin: 8px 0;
    color: #444;
  }

  h3 {
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    color: #111;
  }
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const ButtonWrapper = styled.div`
  margin-top: 16px;
`;

const ViewButton = styled.button`
  width: 100%;
  height: 44px;
  border: 1px solid rgb(167, 140, 76);
  background-color: #000;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 0px;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: rgb(167, 140, 76);
    color: #fff;
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;
const PageButton = styled.button`
  background-color: rgb(167, 140, 76);
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #bc9f8b;
  }
`;
